var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.doShowLogin)?_c('div',[_c('login-dialog',{attrs:{"visible":_vm.showing}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }